import { connect, MapStateToProps } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { AppState } from '../../../../types/store';
import { PostsSortOrder, PostsType } from '../../../../types/posts';
import { isCurrentUserProfileOwner } from '../../../selectors/users';
import { getPostsDeviationsStreamId } from '../../../streams/posts';
import { getModuleDataByModuleType } from '../../../selectors/modules';
import { ModuleType } from '../../../../types/modules';

import { Props, RouteParams } from './PostsSection';

type StateProps = Pick<Props, 'isOwner' | 'isEmpty' | 'streamId' | 'counts'>;
type RouteProps = RouteComponentProps<RouteParams>;
type OwnProps = Omit<Props & RouteProps, keyof StateProps>;

export const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps & RouteProps,
  AppState
> = (state, ownProps) => {
  const username = ownProps.match.params.username;
  const sortOrder = (ownProps.match.params.sortOrder ||
    PostsSortOrder.NEWEST) as PostsSortOrder;
  const postsSection = (ownProps.match.params.postsSection ||
    PostsType.ALL) as PostsType;
  const streamId = getPostsDeviationsStreamId({
    type: postsSection!,
    sortOrder,
  });
  const { counters: counts } = getModuleDataByModuleType(
    state,
    ModuleType.POSTS_FEED
  );
  const isInitialized = streamSelectors.isInitialized(state, streamId);
  const isFetching = streamSelectors.isFetching(state, streamId);
  const isEmpty =
    isInitialized &&
    !isFetching &&
    streamSelectors.getItems(state, streamId).length === 0;
  const isOwner = isCurrentUserProfileOwner(state);

  return {
    isEmpty,
    username,
    sortOrder,
    streamId,
    postsSection,
    isOwner,
    counts,
  };
};

export default connect(mapStateToProps);
